import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/shop-catalog/components/ShopCatalogInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
